import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Widget04 from 'components/Widgets/Widget04';
import { Col } from 'reactstrap';

InfoCards.propTypes = {
    knowledgeWealth: PropTypes.number,
    knowledgeCurrency: PropTypes.number,
    learningCurrency: PropTypes.number,
    totalQuesAnswered: PropTypes.number,
}

InfoCards.defaultProps = {
    knowledgeWealth: 0,
    knowledgeCurrency: 0,
    learningCurrency: 0,
    totalQuesAnswered: 0,
};

function InfoCards({ knowledgeWealth, knowledgeCurrency, learningCurrency, totalQuesAnswered }) {
    const knowledgeWealthToolTip = `What is Total Score?
    It indicates the net learning outcomes calculated by adding learning efficiency and knowledge efficiency with a weightage of 20% & 80% respectively.
`;

const knowledgeCurrencyToolTip = `What is Knowledge Efficiency?
    It measures the learning outcomes of the chapter-end quiz, where the student's conceptual clarity of all topics within that chapter is tested from the total score of 100.
`;

const learningCurrencyToolTip = `What is Learning Efficiency?
    It measures the learning outcomes achieved by a student in a topic. The speed, accuracy, and number of attempts are monitored and tested from the total score of 100.
`;

const overallAccuracyToolTip = `What is Overall Acurracy?    
    It measures the overall accuracy of a student while solving questions in a given chapter. Accuracy is measured as the ratio between the number of correctly answered questions and the total of attempted questions.
`;
//     const knowledgeWealthToolTip = `What is Knowledge Wealth?
//     It is a combination of the Learning Currency and Knowledge Currency with a weightage 
//     of 20% and 80% respectively. It is an assessment of overall effective learning of the student.
// `;

// const knowledgeCurrencyToolTip = `What is Knowledge Currency?
//     Knowledge Currency represents Knowledge Efficiency which measures the learning outcomes based on the 
//     student’s speed accuracy and the number of mistakes in the quiz played at the end of each chapter. 
// `;

// const learningCurrencyToolTip = `What is Learning Currency?
//     Learning Currency represents Learning Efficiency which measures the learning outcomes based on the student’s speed,
//     accuracy and the number of mistakes in a subtopic. 
// `;

// const overallAccuracyToolTip = `What is Overall Acurracy?    
//     It measures the overall accuracy of a student while solving questions in a given chapter. Accuracy is measured as the ratio between the number of correctly answered questions and the total of attempted questions.
// `;
    // const knowledgeWealthToolTip = `
    // It indicates the net learning outcomes calculated by adding learning efficiency and knowledge efficiency with a weightage of 20% & 80% respectively.
    // `;

    // const knowledgeCurrencyToolTip = `
    // It measures the learning outcomes of the chapter-end quiz, where the student's conceptual clarity of all topics within that chapter is tested from the total score of 100.
    // `;

    // const learningCurrencyToolTip = `
    // It measures the learning outcomes achieved by a student in a topic. The speed, accuracy, and number of attempts are monitored and tested from the total score of 100.
    // `;

    // const overallAccuracyToolTip = `  
    // It measures the overall accuracy of a student while solving questions in a given chapter. Accuracy is measured as the ratio between the number of correctly answered questions and the total of attempted questions.
    // `;


    return (
        <Fragment>
            <div className="info-cards-flex no-gutters width-100">
            <div className="info-card">
                <Widget04
                    icon="icon-knowledge-wealth"
                    color="success"
                    header={knowledgeWealth.toString()+' %'}
                    value="0"
                    showInfoIcon={true}
                    toolTip={knowledgeWealthToolTip}
                    className="info-card-bg-main"
                >
                    Total Score
                    {/* Knowledge Wealth */}
                </Widget04>
            </div>
            <div className="info-card">
                <Widget04
                    icon="icon-knowledge-currency"
                    color="warning"
                    header={knowledgeCurrency.toString()+' %'}
                    value="0"
                    showInfoIcon={true}
                    toolTip={knowledgeCurrencyToolTip}
                    className="info-card-bg-all"
                >
                Knowledge Efficiency
                {/* Knowledge Currency */}

                </Widget04>
                </div>
            <div className="info-card">
                <Widget04
                    icon="icon-learning-currency"
                    color="secondary"
                    header={learningCurrency.toString()+' %'}
                    value="0" showInfoIcon={true}
                    toolTip={learningCurrencyToolTip}
                    className="info-card-bg-all"
                >
                    Learning Efficiency
                    {/* Learning Currency */}
                </Widget04>
                </div>
            <div className="info-card">
                <Widget04
                    icon="icon-overall-accuracy"
                    color="danger"
                    // header={totalQuesAnswered.toString()}
                    header={`${totalQuesAnswered.toString()} %`}
                    value="0"
                    showInfoIcon={true}
                    toolTip={overallAccuracyToolTip}
                    className="info-card-bg-all"
                >Overall Accuracy
                </Widget04>
                </div>
            </div>
                </Fragment>
    )
}

export default InfoCards;

